import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {HttpCommonService} from '../../../shared/services/http-common.service';
import {GenericHttpResponse} from '../../../shared/services/interfaces/generic-http-response.interface';
import {ChangePasswordBody, UserPerfil} from './perfil.interface';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  show(): Observable<GenericHttpResponse<UserPerfil>> {
    const url = this.httpCommonService.makeUrl('/profile/user');
    return this.http.get<GenericHttpResponse<UserPerfil>>(url);
  }

  update(body: ChangePasswordBody): Observable<GenericHttpResponse<string[]>> {
    const url = this.httpCommonService.makeUrl('/profile/changePassword');
    return this.http.put<GenericHttpResponse<string[]>>(url, body);
  }
}
